function Button({ onClick, className, icon, text }) {
  return (
    <button
      onClick={onClick}
      className={`${className} transform duration-300 inline-flex focus:scale-95 items-center justify-between w-40 px-4 py-1 m-1 rounded-full`}
    >
      <span className="w-full text-center">{text}</span>
      <div className="ml-2">{icon}</div>
    </button>
  );
}

export default Button;
